import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'
import { mapLoyaltyEsimBenefit } from 'api/mappers/loyalty/mapLoyaltyEsimBenefit'

type SuccessResponse =
  paths['/api/lux-loyalty/esim/orders/{orderId}/details']['get']['responses']['200']['content']['application/json']

export default async function requestLoyaltyEsimOrderDetails(
  orderId: string,
  customerId: string,
): Promise<App.LoyaltyEsimBenefit | undefined> {
  try {
    const response = await requestUtils.get<SuccessResponse>(
      `/api/lux-loyalty/esim/orders/${orderId}/details?customerId=${customerId}`,
      { credentials: 'include' },
    )
    return mapLoyaltyEsimBenefit(response.result)
  } catch(error) {
    if (error && typeof error === 'object' && 'status' in error &&
      (error.status === 404 || error.status === 422)) {
      return undefined
    }
    throw error
  }
}
